import React, { useState } from 'react';
import { useCarFilters } from '../hooks/useCarFilters';
import FiltersSidebar from '../components/catalog/FiltersSidebar';
import SearchBar from '../components/catalog/SearchBar';
import ActiveFilters from '../components/catalog/ActiveFilters';
import SortSelector from '../components/catalog/SortSelector';
import CarsGrid from '../components/catalog/CarsGrid';
import MetaTags from '../components/MetaTags';

const Catalogo = () => {
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const {
    searchTerm,
    setSearchTerm,
    filterOptions,
    filteredCars,
    activeFilters,
    sortBy,
    setSortBy,
    expandedFilters,
    selectedBrand,
    selectedYear,
    selectedFuel,
    selectedTransmission,
    minPrice,
    maxPrice,
    minKm,
    maxKm,
    setSelectedBrand,
    setSelectedYear,
    setSelectedFuel,
    setSelectedTransmission,
    setMinPrice,
    setMaxPrice,
    setMinKm,
    setMaxKm,
    clearFilters,
    removeFilter,
    toggleFilter,
    closeFilter,
    getFilterCount
  } = useCarFilters();

  const handleRemoveFilter = (type, value) => {
    removeFilter(type, value);
    // If removing search filter, close the search menu
    if (type === 'search') {
      setIsSearchOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-sky-50 to-slate-100 pt-14 lg:pt-8">
      <MetaTags 
        title="Catálogo de Autos Usados - MRautomotores Córdoba"
        description="Explorá nuestro catálogo completo de autos usados en Córdoba. Renault, Fiat, Ford, Chevrolet y más marcas disponibles con financiación propia y garantía."
        url="https://mrautomotores.com/catalogo"
      />
      
      <div className="container mx-auto px-4 lg:px-6 py-0 lg:py-6">
        {/* Header */}
        <header className="text-center mb-2 lg:mb-6">
          <h1 className="text-xl lg:text-3xl font-bold text-slate-800 mb-1 lg:mb-3">
            Catálogo de Vehículos
          </h1>
          <p className="text-sm lg:text-lg text-slate-600">
            Encontrá tu auto ideal en Argentina al mejor precio
          </p>
        </header>

        <div className="flex flex-col lg:flex-row gap-3 lg:gap-6">
          {/* Filters Sidebar - Mobile First */}
          <div className="lg:w-1/4 flex-shrink-0">
            <FiltersSidebar
              filterOptions={filterOptions}
              expandedFilters={expandedFilters}
              selectedBrand={selectedBrand}
              selectedYear={selectedYear}
              selectedFuel={selectedFuel}
              selectedTransmission={selectedTransmission}
              minPrice={minPrice}
              maxPrice={maxPrice}
              minKm={minKm}
              maxKm={maxKm}
              onToggleFilter={toggleFilter}
              onCloseFilter={closeFilter}
              onBrandChange={setSelectedBrand}
              onYearChange={setSelectedYear}
              onFuelChange={setSelectedFuel}
              onTransmissionChange={setSelectedTransmission}
              onMinPriceChange={setMinPrice}
              onMaxPriceChange={setMaxPrice}
              onMinKmChange={setMinKm}
              onMaxKmChange={setMaxKm}
              onClearFilters={clearFilters}
              getFilterCount={getFilterCount}
            />
          </div>

          {/* Main Content */}
          <main className="lg:w-3/4 flex-1 min-w-0">
            {/* Search Bar */}
            <div className="mb-2 lg:mb-4">
              <div className={`gap-3 items-center ${isSearchOpen ? 'flex-col' : 'flex'}`}>
                <SearchBar
                  searchTerm={searchTerm}
                  onSearchChange={setSearchTerm}
                  className={isSearchOpen ? 'w-full' : 'flex-1'}
                  onSearchStateChange={setIsSearchOpen}
                />
                {!isSearchOpen && <SortSelector sortBy={sortBy} onSortChange={setSortBy} />}
              </div>
              {isSearchOpen && (
                <div className="w-full mt-3">
                  <SortSelector sortBy={sortBy} onSortChange={setSortBy} />
                </div>
              )}
            </div>

            {/* Results Header */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
              <div className="text-slate-600">
                <span className="text-lg font-bold text-slate-800">
                  {filteredCars.length}
                </span>
                <span className="text-xs ml-2">
                  vehículos encontrados
                </span>
              </div>
            </div>

            {/* Active Filters */}
            {activeFilters.length > 0 && (
              <ActiveFilters
                activeFilters={activeFilters}
                onRemoveFilter={handleRemoveFilter}
                onClearFilters={clearFilters}
              />
            )}

            {/* Cars Grid */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6">
              <CarsGrid cars={filteredCars} />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Catalogo;
